var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"card"}},[_c('div',{staticClass:"d-flex flex-column h-50"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._v(_vm._s(_vm.total))])]),_c('v-icon',{attrs:{"size":"27"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }